import {
  GetBestAndLatestStudentResultAnalysisData,
  GetBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant,
} from "../../actions/teacherQueries";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  CardTitle,
} from "reactstrap";
import StudentFillIn from "../ResultQuestionOverview/StudentFillIn";
import StudentMatching from "../ResultQuestionOverview/StudentMatching";
import StudentMultipleChoice from "../ResultQuestionOverview/StudentMultipleChoice";
import StudentSequence from "../ResultQuestionOverview/StudentSequence";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import Fab from "@mui/material/Fab";

function renderSwitch(data, index) {
  switch (data.type) {
    case "choice":
      return <StudentMultipleChoice data={data} questionIndex={index} />;
    case "sequencing":
      return <StudentSequence data={data} questionIndex={index} />;
    case "matching":
      return <StudentMatching data={data} questionIndex={index} />;
    case "fill-in":
      return <StudentFillIn data={data} questionIndex={index} />;
    case "true-false":
      return <StudentMultipleChoice data={data} questionIndex={index} />;
    case "other":
      return <StudentMultipleChoice data={data} questionIndex={index} />;
    default:
      return <div></div>;
  }
}

export default function StudentResultQuestionOverview({
  studentId,
  courseId,
  moduleId,
  courseName,
  moduleName,
  bestResultIsOpen,
  toggleBest,
  latestResultIsOpen,
  toggleLatest,
  isGy25FinalExam,
  variantId,
}) {
  const studentResultData = isGy25FinalExam
    ? GetBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant(
        studentId,
        variantId
      )
    : GetBestAndLatestStudentResultAnalysisData(studentId, courseId, moduleId);

  if (!studentResultData.data) {
    return <div></div>;
  }

  function linesToParagraphs(...nodes) {
    return nodes
      .map((node) =>
        typeof node === "string"
          ? node.split("\n").map((text) => <p className="mb-0">{text}</p>)
          : node
      )
      .reduce((nodes, node) => nodes.concat(node), []);
  }

  return (
    <div>
      {studentResultData.data &&
        studentResultData.data.length > 0 &&
        studentResultData.data.map((item, index) => {
          return (
            <Row
              key={"item" + index}
              style={{ margin: "0 auto", display: "block", width: "100%" }}
            >
              <Card key={item.studentResultId} className="px-0">
                <CardHeader
                  id={"toggler-" + index}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    index === 0 ? toggleLatest() : toggleBest();
                  }}
                >
                  {" "}
                  <Col
                    style={{
                      marginLeft: "0.5rem",
                      fontWeight: "bolder",
                    }}
                  >
                    <span style={{ fontWeight: "lighter" }}>
                      {item.isBestResult ? (
                        item.isLatestResult ? (
                          <span>
                            <FormattedMessage id="BestAndLatestResult" />
                            <br />
                          </span>
                        ) : (
                          <span>
                            <FormattedMessage id="BestResult" />
                            <br />
                          </span>
                        )
                      ) : item.isLatestResult ? (
                        <span>
                          <FormattedMessage id="LatestResult" />
                          <br />
                        </span>
                      ) : (
                        <span></span>
                      )}
                    </span>
                    <div className="d-flex">
                      <div className="my-auto pe-2">
                        {(index === 1 && bestResultIsOpen) ||
                        (index === 0 && latestResultIsOpen) ? (
                          <FontAwesomeIcon icon="chevron-down" />
                        ) : (
                          <FontAwesomeIcon icon="chevron-right" />
                        )}
                      </div>
                      <span>{courseName}</span>
                      &nbsp;-&nbsp;
                      <span>{moduleName}</span>
                      &nbsp;-&nbsp;
                      <span>{item.cleanTimeStamp}</span>
                    </div>
                  </Col>
                </CardHeader>

                <Collapse
                  isOpen={index === 0 ? latestResultIsOpen : bestResultIsOpen}
                >
                  <CardBody
                    style={{ paddingLeft: "12px", paddingRight: "12px" }}
                  >
                    <Row className="d-flex align-items-stretch my-2">
                      {item.questionAnswerList.map((obj, index) => (
                        <Col key={"qa" + index} md="6" className="d-flex">
                          <Card className="flex-fill">
                            <CardHeader>
                              <CardTitle className="student-result-question--title d-flex align-items-start">
                                <span
                                  style={{
                                    width: "70%",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {obj.question}
                                </span>
                                <span
                                  style={{
                                    width: "30%",
                                    textAlign: "right",
                                    color: obj.correct ? "green" : "red",
                                  }}
                                >
                                  {obj.correct ? (
                                    <FormattedMessage id="Correct" />
                                  ) : (
                                    <FormattedMessage id="IncorrectOrPartlyCorrect" />
                                  )}
                                </span>
                              </CardTitle>
                            </CardHeader>
                            {renderSwitch(obj, index)}
                          </Card>
                        </Col>
                      ))}
                    </Row>
                    <Fab
                      variant="extended"
                      style={{ backgroundColor: "#20a8d8", color: "white" }}
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <FormattedMessage id="ScrollToTop" />
                    </Fab>
                  </CardBody>
                </Collapse>
              </Card>
            </Row>
          );
        })}
      {studentResultData.data && studentResultData.data.length < 1 && (
        <Row
          className="p-1 m-2"
          style={{ border: "2px solid red", borderRadius: "3px" }}
        >
          <Col lg={0.5}>
            <FontAwesomeIcon icon="info-circle" />{" "}
          </Col>
          <Col>
            <h6>
              <FormattedMessage id="ResultOverviewQuestionError">
                {linesToParagraphs}
              </FormattedMessage>
            </h6>
          </Col>
        </Row>
      )}
    </div>
  );
}
